import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import VesselTypeMasterContent from "../../components/Masters/VesselTypeMaster/VesselTypeMasterContent";
import DefectMasterContent from "../../components/Masters/DefectMaster/DefectMasterContent";

const DefectMaster = () => {
  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <DefectMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default DefectMaster;
